import { useFigures } from '@cibo/ui'
import { TableCell, Typography } from '@mui/material'

type FieldNameCellProps = {
  name: string
  acres?: number
}

export const FieldNameCell = ({ name, acres }: FieldNameCellProps) => {
  const { acres: acresFormatter } = useFigures()

  return (
    <TableCell>
      {name}
      <Typography variant="caption" display="block" color="text.secondary">
        {acres ? acresFormatter(acres) : ''}
      </Typography>
    </TableCell>
  )
}
